
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	// Application Title
	'appTitle': 'Proiect Gemini',
	'appExit': 'Mergeţi la pagina Bine aţi venit',


	'widgetsListLabel': 'Lista de widget-uri. Selectaţi un widget şi apăsaţi Enter pentru adăugare.',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	//General
	'listSeparator': ', ',
	'pointSeparator': ':',

	'insync': 'Actual',
	'dirty': 'Nu actual',
	'conflict': 'Conflict la salvarea vizualizării',
	'error': 'Problemă la salvarea vizualizării',
	'failure': 'Imposibil de contactat serverul',
	'saveFailed': 'Imposibil de salvat vizualizarea',

	'wa_insync': 'Salvat',
	'wa_conflict': 'Conflict la salvarea vizualizării',
	'wa_error': 'Imposibil de salvat vizualizarea',
	'wa_failure': 'Imposibil de contactat serverul',

	// Menu Labels
	'changeDisplay': 'Modificare afişare',
	'changeToColumnChart': 'Modificare la diagrama coloană',
	'changeToBubbleChart': 'Modificare la diagrama cu bule',
	'toggleMoveHandles': 'Comutare handle-uri de mutare',
	'undo': 'Anulare acţiune',
	'redo': 'Refacere',
	'mode': 'Modificarea modului',

	'untitled': 'Fără titlu',
	'remove': 'Înlăturare',
	'editTitle': 'Editarea titlului',
	'edit': 'Editare',
	'done': 'Gata',

	// Data tray
	'dataTrayHandleOpenLabel': 'Deschidere bară de date',
	'dataTrayHandleCloseLabel': 'Închidere bară de date',

	// Dialogs
	'dlg_loading': 'Încărcare...',
	'dlg_ok': 'OK',
	'dlg_create': 'Creare',
	'dlg_cancel': 'Anulare',
	'dlg_close': 'Închidere',
	'dlg_update': 'Actualizare',
	'dlg_renameBoardTitle': 'Redenumiţi acest obiect',
	'dlg_renameDatasetTitle': 'Redenumiţi acest set de date',
	'dlg_renameSceneTitle': 'Redenumiţi acest scenă',
	'dlg_NameLabel': 'Nume:',
	'dlg_NewNameLabel': 'Nume nou:',
	'dlg_DefaultNameWithDataSet': '%{name} View',
	'dlg_ShareTitle': 'Partajare conţinut',
	'dlg_UnshareTitle': 'Înlăturare partajare conţinut',
	'dlg_ShareUser': 'ID utilizator:',
	'dlg_NewColumnLabel': 'Nume calcul nou',

	'dlg_new': 'Nou...',
	'dlg_open': 'Deschidere...',
	'dlg_makeACopy': 'Faceţi o copie',
	'dlg_rename': 'Redenumire...',
	'dlg_moreToCome': 'Mai multe acţiuni care urmează ...',

	'dlg_use': 'Utilizare',

	'dlg_RelinkDatasetTitle': 'Replace data set \'%{datasetName}\' with ...',

	'open_error': 'A apărut o problemă în timpul deschiderii vizualizării.',

	// Delete Board
	'del_dialogTitle': 'Confirmare ştergere',
	'del_itemMsg': 'Are you sure you want to delete \'%{name}\'?',
	'del_itemsMsg': 'Are you sure you want to delete %{count} items?',
	'del_deleteErr': 'Unable to delete \'%{name}\'',

	// List Sorting
	'dlg_ascending': 'crescător',
	'dlg_descending': 'descrescător',
	'dlg_custom': 'personalizat',
	'dlg_none': 'fără',

	// Input Placeholders
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'search': 'Căutare',

	'searchHint': 'Căutaţi toate datele dumneavoastră',
	'clearSearchResult': 'Curăţarea rezultatelor de căutare',
	// Shapes and shapes categories
	// Basic shapes
	'shapesCircle': 'Cerc',
	'shapesHexagon': 'Hexagon',
	'shapesLine': 'Linie',
	'shapesOctagon': 'Octogon',
	'shapesPentagon': 'Pentagon',
	'shapesSquare': 'Pătrat',
	'shapesTriangle': 'Triunghi',
	'shapesDiamond': 'Romb',
	'shapesTitle': 'Proprietăţi de formă', // TODO: becomes "Shape" when FF 'PropertiesV2' is enabled


	// Advanced shapes
	'shapesSquareRounded': 'Pătrat rotunjit',
	'shapesStar': 'Stea',
	'shapesChevron': 'În zigzag',
	'shapesBadge_ribbon': 'Panglică ecuson',
	'shapesBadge': 'Ecuson',
	'shapesHeart': 'Inimă',
	'shapesExclamation': 'Exclamare',
	'shapesTrendingup': 'Tendinţă în sus',
	'shapesTrendingdown': 'Tendinţă în jos',
	'shapesX': 'X',

	// People shapes
	'shapesPeopleCat': 'Persoane',
	'shapesFemale': 'De sex feminin',
	'shapesHappyface': 'Față veselă',
	'shapesMale': 'De sex masculin',
	'shapesMan': 'Bărbat',
	'shapesNeutralface': 'Faţă neutră',
	'shapesSadface': 'Faţă tristă',
	'shapesShakehands': 'Strângere de mâini',
	'shapesThumbsdown': 'Degete mari în jos',
	'shapesThumbsup': 'Degete mari în sus',
	'shapesWoman': 'Femeie',

	// Weather and places
	'shapesPlacesWeatherCat': 'Vremea & în diferite locuri',
	'shapesCity': 'Localitate',
	'shapesCloud': 'Cloud',
	'shapesEducation': 'Învăţământ',
	'shapesGovernment': 'Guvern',
	'shapesHalfcloud': 'Jumătate de Cloud',
	'shapesHouse': 'Casă',
	'shapesMoon': 'Lună',
	'shapesRain': 'Ploaie',
	'shapesSunny': 'Însorit',

	//Vehicles
	'shapesVehiclesCat': 'Vehicule',
	'shapesAirplane': 'Avion',
	'shapesCar': 'Maşină',
	'shapesShip': 'Vapor',
	'shapesShoppingcart': 'Coş de cumpărături',
	'shapesTrain': 'Tren',
	'shapesTruck': 'Camion',

	//Objects
	'shapesObjectsCat': 'Obiecte',
	'shapesBook': 'Agendă',
	'shapesBriefcase': 'Servietă',
	'shapesCalendar': 'Calendar',
	'shapesCheck': 'Verificare',
	'shapesClock': 'Ceas',
	'shapesDesktop': 'Desktop',
	'shapesDocument': 'Document',

	'shapesFood': 'Alimente',
	'shapesGear': 'Echipamente',
	'shapesHealth': 'Sănătate',

	'shapesIdea': 'Idee',
	'shapesMobile': 'Mobil',
	'shapesMoney_bill': 'Bancnotă',
	'shapesMoney_coin': 'Monedă',
	'shapesPiggybank': 'Pușculiță',
	'shapesStackofpaper': 'Stivă de hârtie',
	'shapesStickynote1': 'Notă adezivă 1',
	'shapesStickynote2': 'Notă adezivă 2',
	'shapesTarget': 'Ţintă',
	'shapesTool': 'Unealtă',

	'shapesUmbrella': 'Umbrelă',

	'shapesBrain': 'Creier',
	'shapesSkull': 'Craniu',
	'shapesEye': 'Ochi',

	// Arrows shapes
	'shapesArrowsCat': 'Săgeţi',
	'shapesRightArrow': 'Săgeată la dreapta',
	'shapesLeftArrow': 'Săgeată la stânga',
	'shapesDoubleArrow': 'Săgeata dublă',
	'shapesCurvedArrow': 'Săgeată curbată',

	// Callouts shapes
	'shapesCalloutsCat': 'Explicaţii',
	'shapesRectCallout': 'Explicaţie',

	// Images
	'imagesCat': 'Imagini',
	'imageWidgetTitle': 'Widget Imagine',
	'imgUrl': 'URL imagine',
	'noImgSelected': 'No image selected',
	'enterImgUrl': 'Enter image URL here',
	'imgPasteLink': 'Paste the URL and press Enter to save it.',
	'imgResizeToFit': 'Redimensionare pentru a se potrivi mărimea imaginii',
	'imgHeight': 'Înălţime:',
	'imgWidth': 'Lăţime:',
	'imgTransparency': 'Transparenţă:',
	'imgMissingUrl': 'The image URL is missing.',
	'imgUrlValidationError': 'The image URL is not valid.',
	'imgUrlInvalidDomainError': 'URL-ul de imagine indică la un domeniu care nu este aprobat de administratorul dumneavoastră. The domains approved by your administrator are "%{domains}".',

	// line shape
	'propStrokeWidth': 'Grosime linie',
	'propStrokeDashArray': 'Stil linie',
	'propStrokeSolidline': 'Linie solidă',
	'propStrokeLineCap': 'Capăt linie',
	'propStrokeLineCapButt': 'Plat',
	'propStrokeLineCapRound': 'Rotund',
	'propStrokeLineCapSquare': 'Pătrat',

	// Data player widget
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'playButtonLabel': 'Redare',
	'dataPlayerValueListLabel': 'Valori cititor de date',
	// Text Widget
	'textWidgetTitle': 'Widget text',
	'textStyle': 'Stiluri',
	'textStyleDescription': 'Stiluri de text preformate',
	'textTitleStyle': 'Titlu',
	'textTitleSmallStyle': 'Titlu mic',
	'textSubtitleStyle': 'Subtitlu',
	'textBodyStyle': 'Corp',
	'textBodySmallStyle': 'Corp mic',
	'textCaptionStyle': 'Subtitlu',
	'textQuoteStyle': 'Ghilimele',
	'textQuoteSmallStyle': 'Ghilimele mici',
	'textResponsiveStyle': 'Dimensionare automată',
	'textAutoFontSize': 'Automat',
	// TODO: Carbon design removes Font Family subClass, no longer needed when FF 'PropertiesV2' is enabled
	// START: Remove FontFamilySubClass
	'textFontFamilySubClassHairline': 'Linie fină',
	'textFontFamilySubClassThin': 'Subţire',
	'textFontFamilySubClassThinItalic': 'Cursiv subţire',
	'textFontFamilySubClassExtraLight': 'Extra-luminos',
	'textFontFamilySubClassExtraLightItalic': 'Cursiv extra-luminos',
	'textFontFamilySubClassLight': 'Luminos',
	'textFontFamilySubClassLightItalic': 'Cursiv luminos',
	'textFontFamilySubClassRegular': 'Obişnuit',
	'textFontFamilySubClassRegularItalic': 'Cursiv obişnuit',
	'textFontFamilySubClassItalic': 'Cursiv',
	'textFontFamilySubClassMedium': 'Mediu',
	'textFontFamilySubClassMediumItalic': 'Cursiv mediu',
	'textFontFamilySubClassHeavy': 'Greu',
	'textFontFamilySubClassHeavyItalic': 'Cursiv greu',
	'textFontFamilySubClassDemiBold': 'Semi-aldin',
	'textFontFamilySubClassDemiBoldItalic': 'Cursiv semi-aldin',
	'textFontFamilySubClassBold': 'Aldin',
	'textFontFamilySubClassBoldItalic': 'Cursiv aldin',
	'textFontFamilySubClassExtraBold': 'Extra-aldin',
	'textFontFamilySubClassExtraBoldItalic': 'Cursiv extra-aldin',
	'textFontFamilySubClassBlack': 'Negru',
	'textFontFamilySubClassBlackItalic': 'Cursiv negru',
	'textFontFamilySubClassStencil': 'Stencil',
	// END: Remove FontFamilySubClass

	'responsiveCoachmarkTitle': 'Dimensionare automată font',
	'responsiveCoachmarkContents': 'Mărimea fontului este redimensionată automat pentru a se potrivi atunci când redimensionaţi acest tip de text. Puteţi seta mărimea fontului în proprietăţile textului.',

	'propText': 'Detalii de text', // TODO: no longer needed when FF 'PropertiesV2' is enabled, replaced with 'Details'
	'propTextReturn': 'Proprietăţi text', // TODO: becomes "Text" when FF 'PropertiesV2' is enabled

	'textFontSize': 'Mărime font',
	'textFontFamily': 'Familie de fonturi',
	'textFontWeight': 'Grosime font', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// Widget Properties
	'propImageLink': 'Legătură imagine',
	'propMissingURL': 'Introducere URL',
	'propImgTop': 'Proprietăţi imagine', // TODO: becomes "Image" when FF 'PropertiesV2' is enabled
	'propGeneralReturn': 'Proprietăţi generale', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propStyle': 'General', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propStyleReturn': 'General', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propFillColor': 'Culoare de umplere', // TODO: becomes "Background color" when FF 'PropertiesV2' is enabled
	'propTextColor': 'Culoare text', // TODO: becomes "Color" when FF 'PropertiesV2' is enabled
	'propBorderColor': 'Culoare bordură',
	'propMaintainAxisScales': 'Menţinere scală pe axă',
	'propShowItemLabel': 'Afişare etichetă articol',
	'propHideLegend': 'Ascundere legendă',
	'propColorPalette': 'Paletă',
	'propLegendPosition': 'Poziţie legendă',
	'propHideAxisTitleLabels': 'Ascundere titluri pe axă',
	'propLineColor': 'Culoare linie',
	'propBubbleColor': 'Culoare bulă',
	'propInterpolation': 'Linii line',
	'propElementColor': 'Vizualizare culoare element',
	'propSymbolShape': 'Formă de simbol',
	'propHeatScalePalette': 'Ordinea culorilor',
	'propHeatScalePalette_tooltipDarkerForLowerValue': 'Culorile mai închise reprezintă valori mai mici.',
	'propHeatScalePalette_tooltipDarkerForHigherValue': 'Culorile mai închise reprezintă valori mai mari.',
	'propImageDetails': 'Detalii imagine', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propWebDetails': 'Detalii pagină de Web', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propMediaDetails': 'Detalii de mediu', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propPasteLink': 'Enter the URL and press Enter.',

	//Layout Properties
	'sectionName_positionAndStyle': 'Position & style',
	'propPositionLabel': 'Poziţie', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propPositionXAxis': 'X', // TODO: becomes 'X position' when FF 'PropertiesV2' is enabled
	'propPositionYAxis': 'Y', // TODO: becomes 'Y position' when FF 'PropertiesV2' is enabled
	'propResizeLabel': 'Dimensiune', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propResizeWidth': 'Lăţime',
	'propResizeHeight': 'Înălţime',
	'propRotateLabel': 'Rotaţie',
	'propRotateAngle': 'Unghi', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'propScaleLabel': 'Cantitatea de pictograme',
	'propScaleDescription': 'Selectaţi cantitatea de pictograme',
	'propScaleFew': 'Scăzut',
	'propScaleDefault': 'Implicit',
	'propScaleMany': 'Nivel ridicat',

	/* PropertyV2 controls */
	// InputLabel - number
	'propInputLabel_number_invalid': 'This value must be numeric',

	'mediaAriaLabel': 'URL intrare',
	'dropdownAriaLabel' : 'Dropdown',
	'ariaGroupLabel': 'Dropdown list category: %{cateoryLabel} item: %{itemLabel}. Apăsaţi tasta DOWN pentru a expanda. Apăsaţi tasta UP şi tasta DOWN pentru a naviga sau apăsaţi tasta ESCAPE pentru a restrânge.',

	// Timer
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'lastRefresh': 'Last refresh: %{timeInterval} ago',
	'widgetTimer': 'Cronometru Widget',

	// Theme colors
	'transparent': 'Fără culoare',
	'white': 'Alb',
	'lightGrey': 'Gri deschis',
	'grey': 'Gri',
	'darkGrey': 'Gri închis',
	'black': 'Negru',
	'lightBlue': 'Albastru deschis',
	'blue': 'Albastru',
	'darkBlue': 'Albastru închis',
	'yellow': 'Galben',
	'orange': 'Portocaliu',
	'lime': 'Verde deschis',
	'green': 'Verde',
	'peach': 'Piersică',
	'red': 'Roşu',
	'violet': 'Violet',
	'aqua': 'Albastru deschis',
	'purple': 'Violet',
	'plum': 'Prună',
	'gray10': 'Grey 10',
	'gray20': 'Grey 20',
	'gray30': 'Grey 30',
	'gray50': 'Grey 50',
	'gray60': 'Grey 60',
	'gray70': 'Grey 70',
	'gray80': 'Grey 80',
	'gray90': 'Grey 90',
	'gray100': 'Grey 100',
	'blue50': 'Blue 50',
	'blue60': 'Blue 60',
	'blue70': 'Blue 70',
	'green40': 'Green 40',
	'green50': 'Green 50',
	'red50': 'Red 50',
	'red60': 'Red 60',


	//Theme Palette Label
	'paletteLabel': 'IBM palette %{number}',
	'heatPaletteLabel': 'IBM heat palette %{number}',
	'conditionalPaletteLabel': 'IBM conditional palette %{number}',
	'carbonPaletteXLight': 'Carbon X luminos',
	'carbonPaletteXDark': 'Carbon X întunecat',
	'carbonPalettePurple': 'Violet',
	'carbonPaletteTeal': 'Turcoaz',
	'carbonPaletteCyan': 'Cyan',
	'carbonPaletteMagenta': 'Magenta',
	'carbonPalettePurpleTeal': 'Purpuriu Verde-albăstrui',
	'carbonPaletteCyanMagenta': 'Cyan Magenta',
	'carbonPaletteGreenRed': 'Verde Roşu',
	'carbonPaletteGreenYellowRed': 'Verde Galben Roşu',
	'carbonPalettePurpleTealConvergent': 'Purpuriu Verde-albăstrui convergent',
	'carbonPaletteCyanMagentaConvergent': 'Cyan Magenta convergent',

	// TODO: Remove the following strings when the colour palette UI is removed
	'userPaletteColor_lightTheme': 'Paletă luminoasă IBM',
	'userPaletteColor_defaultTheme': 'Paletă implicită IBM',
	'userPaletteColor_darkTheme': 'Plată întunecată IBM',

	// Dashboard
	'propDashboardBackgroundColor': 'Culoare fundal',
	'propLayoutPositioning': 'Poziţionare dispunere',
	'propLayoutRelative': 'Relativă',
	'propLayoutAbsolute': 'Absolută',
	'propLayoutPositioningCoachmarkTitle': 'Selectaţi un stil de dispunere',
	'propLayoutPositioningCoachmarkContent': 'Într-o dispunere relativă, mărimea şi poziţia widget-urilor se ajustează pentru a se potrivi în ecran. Widget-urile dintr-o dispunere absolută apar exact cum le-aţi dimensionat şi le-aţi plasat în vizualizare, indiferent de mărimea ecranului.',
	'gridText': 'Afişare grilă',
	'snapText': 'Fixare la grilă',
	'snapObjectsText': 'Fixare la obiecte',
	'fitPageText': 'Potrivire pagină',
	'gridLabel': 'Grilă',
	'heightUnit': 'î',
	'widthUnit': 'l',
	'pixelUnit': 'px',
	'propPageSizeLabel': 'Mărime pagină',
	'propPageSizePresetAriaLabel': 'Presetare mărime pagină',
	'propPageSizePreset': 'Presetată',
	'propPageSizePresetCustom': 'Personalizat',
	'propPageSizePreset16x9': 'Ecran 16:9',
	'propPageSizePreset4x3': 'Ecran 4:3',
	'propPageSizePresetInfographic': 'Infografic',
	'propPageSizeWidth': 'Lăţime',
	'propPageSizeHeight': 'Înălţime',
	'propPageSizeWidthAriaLabel': 'Lăţime mărime pagină',
	'propPageSizeHeightAriaLabel': 'Înălţime mărime pagină',
	'propPageSizeAdjustedMessage': 'A fost crescută mărimea paginii, deoarece valoarea introdusă era sub valoarea minimă sau nu era potrivită pentru tabloul dumneavoastră de bord.',
	'propTabShow': 'Afişare file',
	'propShowTabsInPreview': 'Show tabs in preview',
	'multilingualDashboardsLabel': 'Limbi',
	'multilingualDashboardsDefault': '%{defaultLanguage} -- Default',
	'multilingualDashboardsAddLinkText': 'Adăugare altă limbă',
	'multilingualDashboardsSelect': 'Selectare',
	'multilingualDashboardsButtonLabel': 'Adăugare',
	'multilingualDashboardTranslationMode': 'You are now in translation mode (%{currentLanguage})',
	'multilingualDashboardTranslationDone': 'Gata',
	'multilingualDashboardRemainingStrings': '%{numTranslationsLeft} translations remaining',
	'multilingualDashboardRemainingString': '1 traducere rămasă',
	'multilingualDashboardsSetDefault': 'Setare limbă implicită',
	'multilingualDashboardIconMore': 'More actions for language %{currentLanguage}',
	'multilingualDashboardIconTranslatableArea': 'Zonă traductibilă',
	'multilingualDeleteTitle': 'Ştergere limbă',
	'multilingualDeleteLanguageWarning': 'Are you sure you want to delete the language \'%{language}\'?',
	'multilingualSelectLanguage': 'Selectare limbă',
	'confirmLayoutStyleUpgradeTitle': 'Aplicare pentru toate filele',
	'confirmLayoutStyleUpgrade': 'Aplicaţi acest stil de dispunere pentru toate filele din tabloul de bord?',

	//Tabs
	'tabDeleteDialogPrimaryButton': 'Ştergere',
	'tabDeleteDialogTitle': 'Ştergeţi această filă?',
	'tabDeleteDialogMessage': 'Va fi şters de asemenea întregul conţinut din această filă.',

	// Vis widget
	'propVisTypeReturn': 'Tipuri de vizualizare',
	'propVisDetails': 'Detalii',

	// Alignment picker
	'propAlignPickTop': 'Aliniere sus',
	'propAlignPickRight': 'Aliniere la dreapta',
	'propAlignPickBottom': 'Aliniere jos',
	'propAlignPickLeft': 'Aliniere la stânga',
	'propAlignPickCenter': 'Aliniere la centru',
	'propAlignPicker': 'Aliniere',

	// Toolbar picker
	'propToolbarPickBold': 'Aldin',
	'propToolbarPickUnderline': 'Subliniere',
	'propToolbarPickItalic': 'Cursiv',
	'propToolbarPickJustifyLeft': 'Aliniere la stânga',
	'propToolbarPickJustifyCenter': 'Aliniere la centru',
	'propToolbarPickJustifyRight': 'Aliniere la dreapta',
	'propToolbarPickJustify': 'Aliniere stânga-dreapta',

	'propList': 'Listă',
	'propOrderedList': 'Listă ordonată',
	'propUnorderedList': 'Listă neordonată',

	// Symbol shapes
	'propCircle': 'Cerc',
	'propTriangle': 'Triunghi',
	'propSquare': 'Pătrat',
	'propRect': 'Dreptunghi',
	'propStar': 'Stea',
	'propCross': 'Încrucişat',
	'propPlus': 'Plus',
	'propPoly': 'Poligon',


	// True and false selection
	'propTrue': 'True',
	'propFalse': 'False',

	// Position selection
	'propLeft': 'Stânga',
	'propRight': 'Dreapta',
	'propTop': 'Sus',
	'propBottom': 'Jos',

	// Interpolation options
	'propSmooth': 'Lin',
	'propStraight': 'Drept',

	// indentedListView
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'srILVTreeLabel': 'Listă', // screen reader label for tree role

	// widget move
	'srWidgetMoveLeft': 'Mutare la stânga', // screen reader
	'srWidgetMoveUp': 'Mutare în sus', // screen reader
	'srWidgetMoveRight': 'Mutare la dreapta', // screen reader
	'srWidgetMoveDown': 'Mutare în jos', // screen reader

	// widget resize
	'srWidgetResizeBigger': 'Creşterea mărimii proporţional', // screen reader
	'srWidgetResizeSmaller': 'Descreşterea mărimii proporţional', // screen reader
	'srWidgetResizeBiggerV': 'Creşterea mărimii pe verticală', // screen reader
	'srWidgetResizeSmallerV': 'Descreşterea mărimii pe verticală', // screen reader
	'srWidgetResizeBiggerH': 'Creşterea mărimii pe orizontală', // screen reader
	'srWidgetResizeSmallerH': 'Descreşterea mărimii pe orizontală', // screen reader

	// widget rotate
	'srWidgetRotateCW': 'Rotire în sensul acelor de ceasornic', // screen reader
	'srWidgetRotateCCW': 'Rotire în sens contrar acelor de ceasornic', // screen reader

	// Recommended types
	'visChange': 'Modificare vizualizare',

	// Visualization
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'visualizationLabel': 'Vizualizare',
	'chartLabel': '%{chartName} chart',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': 'Apăsaţi F12 pentru a naviga în widget',
	'f10KeyDescription': 'Apăsaţi F10 pentru a lansa vizualizarea de focalizare widget',

	'WidgetLabelWithDescripion': '%{label}. %{description}',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'summaryLabel': '%{label} with value %{value}',

	'shapeColorLabel': 'Culoare formă',
	'showLegendLabel': 'Afişare legendă',

	//Webpage
	'webpageWidgetTitle': 'Widget Pagină web',
	'webpagePasteLink': 'Paste the URL and press Enter to save it.',
	'propWebpageLink': 'URL-ul de pagină Web',
	'propWebpageTitle': 'Titlu pagină de Web',
	'propWebpageTitleDescription': 'Titlul paginii de Web',
	'webpageUrl': 'Webpage URL',
	'noWebpageSelected': 'No webpage selected',
	'enterWebpageUrl': 'Enter webpage URL here',
	'propWebpageTop': 'Proprietăţi pagină de Web', // TODO: becomes "Web page" when FF 'PropertiesV2' is enabled
	'webpageMissingUrl': 'The web page URL is missing.',
	'webpageUrlValidationError': 'The web page URL is not valid.',
	'webpageHttpValidationError': 'The web page must be accessed using an HTTPS link.',
	'webpageInvalidDomainError': 'URL-ul de pagină web indică la un domeniu care nu este aprobat de administratorul dumneavoastră. The domains approved by your administrator are "%{domains}".',

	//VizState
	'vzErrorLoading': 'Imposibil de încărcat vizualizarea',
	'vzErrorLoadingMissingData': 'Imposibil de încărcat vizualizarea, lipsesc date de context',

	//Media (Video / Audio)
	'mediaWidgetTitle': 'Widget mediu',
	'mediaPasteLink': 'Paste the URL and press Enter to save it.',
	'mediaUrl': 'Media URL',
	'noMediaSelected': 'No media selected',
	'enterMediaUrl': 'Enter media URL here',
	'videoHeight': 'Înălţime:',
	'videoWidth': 'Lăţime:',
	'propMediaLink': 'Legătură la mediu',
	'propMediaTitle': 'Titlu mediu',
	'propMediaTitleDescription': 'Titlul mediului',
	'propMediaTop': 'Proprietăţi de mediu', // TODO: becomes "Media" when FF 'PropertiesV2' is enabled
	'mediaMissingUrl': 'The media link URL is missing.',
	'mediaUrlValidationError': 'The media file URL is not valid.',
	'mediaUnknownValidationError': 'This type of media is not supported.',
	'mediaHttpValidationError': 'The media file must be accessed using an HTTPS link.',
	'mediaInvalidDomainError': 'URL-ul de fişier media indică la un domeniu care nu este aprobat de administratorul dumneavoastră. The domains approved by your administrator are "%{domains}".',

	// Properties pane
	'commonPropertiesLabel': 'Proprietăţi', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// Data strip
	'dataSetsLabel': 'Set de date',
	'dataViewsLabel': 'Vizualizare',
	'columnQuality': 'Calitate de date',
	'columnProperties': 'Proprietăţi de date',

	'dataQuality': 'Calitate de date',
	'dataQualityRowCount': 'Număr de rânduri',
	'dataQualityDistribution': 'Distribuţie',
	'dataRowLabel': 'Date',

	// Modelling UI
	'typeColumn': 'Tip',
	'modellingColumnType': 'Tip',
	'modellingColumnAggregation': 'Agregare',
	'modellingColumnUsage': 'Utilizare',
	'modellingColumnSort': 'Sortare',
	'modellingColumnFormat': 'Format',
	'modellingColumnCategory': 'Categorie',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingLoading': 'Încărcare...',

	'modellingProcessing': 'Procesare...',
	'modellingImport': 'Import',
	'modellingReimport': 'Re-import',
	'modellingDatasourceTitle': 'Sursă de date',
	'modellingImportStartedTitle': 'Importul a început',
	'modellingImportStartedText': 'Importing your data may take a bit of time.\n\n(You can create a view while the data is imported.)',
	'importDatasourceTitle': 'Conexiuni',
	'dropHere': 'Plasaţi aici pentru a crea o nouă sursă de date...',
	'browseButton': 'Răsfoire',
	'errorNoData': 'Nu există date de procesare.',
	'errorNoFile': 'Nu există niciun fişier de încărcat.',
	'errorUploadFailed': 'Imposibil de încărcat.',
	'uploadSucceessful': 'Încărcare reuşită',
	'del_datasourceTitle': 'Ştergere set de date',
	'del_datasourceMsg': 'Are you sure you wish to delete \'%{name}\'?',
	'modellingFileUpdate': 'Actualizare',
	'modellingFileUpdateTitle': 'Actualizare set de date',
	'modellingFileUpdateDescription': 'Do you want to update \'%{name}\'?',
	'modellingFileUpdatingTitle': 'Updating \'%{name}\'',
	'modellingUpdateStartedTitle': 'Importul de actualizare a început',
	'modellingUpdateStartedText': 'Updating your data may take a bit of time.\n\n(You can create a view while the data is updated.)',
	'modellingErrorImportUploadNoFile': 'Niciun fişier de încărcat.',
	'modellingErrorImportUploadFailed': 'Imposibil de încărcat.',
	'modellingErrorImportUploadInvalidType': 'Tipul de fişier nu este valid.',
	'modellingErrorImportUploadTableFailed': 'Imposibil de obţinut tabele.',
	'modellingIntentResultsTitle': 'Selectaţi setul de date propus pentru utilizare',
	'modellingColumnViewRelationships': 'Vizualizare tabele înrudite',
	'modellingTableRelatedTables': 'Tables related to \'%{name}\'',
	'modellingTable': '%{name} - Table',
	'modellingColumnIncludedInDataSet': 'Adăugat',
	'modellingDataSet': 'Set de date',
	'modellingViewInDataSet': 'Vizualizare în setul de date',
	'modellingViewRelatedTables': 'Vizualizare înrudită',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingRelatedTablesNoneFound': 'Nu au fost găsite tabele înrudite',

	'modellingValidatingDataset': 'Validare...',
	'datasetFinishedRefreshing': 'Data set %{datasetName} has been refreshed.',



	// Join UI - Navigation Controller titles
	'modellingJoinTable': 'Rezolvare cale de unire:',
	'modellingJoinColumns': 'Define a join path for table: %{name}',
	'modellingJoinToTable': 'Join to table: %{name}',

	// Data Quality
	'excluded': 'Exclus',
	'metricPrefixThousand': 'K',
	'metricPrefixMillion': 'L',
	'metricPrefixBillion': 'B',
	'metricPrefixTrillion': 'T',
	'metricPrefixQuadrillion': 'T',

	//Column Flyout
	'modellingColumnFilter': 'Filtru',
	'modellingColumnSortNone': 'Curăţare sortare',
	'modellingColumnSortAsc': 'Sortare crescătoare',
	'modellingColumnSortDesc': 'Sortare descrescătoare',
	'modellingColumnRemove': 'Înlăturaţi această coloană',

	// Import File Browser
	'dropboxPageTitle': 'Conexiune nouă la Dropbox',
	'sizeColumn': 'Dimensiune',

	//Modelling Column Property Values
	'dataType_string': 'Şir',
	'dataType_date': 'Dată',
	'dataType_integer': 'Număr întreg',
	'dataType_double': 'Dublu',
	'dataType_float': 'Flotant',
	'dataType_boolean': 'Boolean',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'defaultAggregation_count': 'Numărare',
	'defaultAggregation_countdistinct': 'Număr distinct',
	'defaultAggregation_max': 'Maxim',
	'defaultAggregation_min': 'Minim',
	'defaultAggregation_avg': 'Mediu',
	'defaultAggregation_sum': 'Sumă',
	'defaultAggregation_auto': 'Auto (%{aggregationType})',

	'type_fact': 'Fapt',
	'type_attribute': 'Atribut',

	'defaultSort_none': 'Nu sortaţi',
	'defaultSort_asc': 'Sortare crescătoare',
	'defaultSort_desc': 'Sortare descrescătoare',

	'category_none': 'Fără',
	'category_location': 'Locaţie',
	'category_monetary': 'Monetar',
	'category_time': 'Oră',

	// Root menu
	'rootMenuTitle': 'Meniu principal',

	'errorMessageTitle': 'Eroare',
	'errorMessageDetails': 'Detalii: ',
	'errorMessageTitleAssetAlreadyExists': 'Activul există deja',

	'defaultTabTitle': 'Fila %{index}',
	'tabAddBtnTitle': 'Adăugaţi o nouă filă',

	'unsupportedConditionalFormattingEncountered': 'Conditional formatting is no longer applied to some columns.',


	// Homepage View
	'nameColumn': 'Nume',
	'creatorColumn': 'Creat de',
	'creationDateColumn': 'Creat la data',
	'versionColumn': 'Versiune',
	'modifiedColumn': 'Ultimul modificat',

	'filterBy': 'Filtrare articole',
	'allFilter': 'Toate articolele',
	'createdByMeFilter': 'Creat de mine',
	'sharedWithMeFilter': 'Partajat cu mine',
	'favoritesFilter': 'Favoritele mele',
	'recentsFilter': 'Recent adăugat',
	'sortBy': 'Sortare după',

	// Sort Menu
	'sortModified': 'Modificat',
	'sortUpdated': 'Actualizat',
	'sortName': 'Nume',

	'viewAs': 'Vizualizare ca',
	'thumbnailsView': 'Vizualizare ca miniaturi',
	'listView': 'Vizualizare ca listă',
	'createMenu': 'Creare',
	'newAppItem': 'Tablou de bord',
	'newDataSet': 'Set de date',

	'menuSelectionState_a11y': '"%{item}" selector set to "%{selectedItem}"',

	'unableToShareItem': 'Unable to share item "%{item}".',
	'toastFetchingContent': 'Se obţine mai mult conţinut...',
	'unableToGetData': 'Imposibil de obţinut conţinut.',
	'unableToFavorite': 'Nu se poate modifica starea Favorită.',
	'hpErrorMissingRequiredOptions': 'Opţiuni de iniţializare necesare lipsă',
	'unableToOpenBoard': 'Unable to open "%{name}".',
	'unableToDuplicateBoard': 'Unable to duplicate "%{name}".',
	'unableToCreateBoard': 'Unable to create "%{name}".',
	'unableToCreateBoardNameConflict': 'Există deja un activ cu acelaşi nume.',

	// DataSet Detail View
	'status': 'Stare',
	'numberOfRows': 'Rânduri',
	'importWarnings': 'Avertismente',
	'lineNumbers': 'Linii',
	'excerptFromSource': 'Extras',
	'reason': 'Motiv',
	'numberOfRowsDropped': 'rânduri plasate',
	'oneRowDropped': '1 rând a fost plasat',

	// Type Menu
	'typeMenuLabel': 'Tip',
	'dashboardsLabel': 'Tablouri de bord',
	'datasetsLabel': 'Seturi de date',
	'storiesLabel': 'Poveşti',
	'allLabel': 'Toate tipurile',

	// Board Page View App Bar
	'datasets': 'Seturi de date',
	'settings': 'Proprietăţi',
	'add': 'Adăugare',
	'widgets': 'Widget-uri',
	'dashboardProperties': 'Proprietăţi tablou de bord',
	'searchPanel' : 'Căutare',
	'pins': 'Colecţie',
	'pinsOld': 'Pinii mei',
	'pinsDateFilterHeading' : 'Date Pinned',
	// For languages with more than one plural form, provide the different forms delimited by |||| in the string below.
	// See https://github.com/airbnb/polyglot.js#pluralization
	'pinCount': '%{smart_count} pin |||| %{smart_count} pins',
	'pinSearch': 'Căutare',
	'pinSearchOld': 'Căutare ţintuiri',
	'pinListView': 'Vizualizare listă',
	'pinIconView': 'Vizualizare pictograme',
	'pinRemove': 'Înlăturare',
	'pinCreate': 'Creare',
	'pinDeleteError': 'Nu putem şterge unul sau mai multe active din colecţie. Încercaţi din nou mai târziu.',
	'pinDeleteErrorOld': 'Nu putem şterge una sau mai multe ţintuiri. Încercaţi din nou mai târziu.',
	'pinRetrieveError': 'Nu putem extrage una sau mai multe ţintuiri. Încercaţi din nou mai târziu.',
	'NoPinsCollected': 'Nicio vizualizare ţintuită',
	'pinDeletedToast': 'Ţintuirea a fost înlăturată',
	'pinAddedToast': 'Ţintuirea a fost adăugată cu succes la Ţintuirile mele',
	'pinningToast': 'Procesare pin...',
	'pinDateFilter': 'Filtru dată',
	'pinDateFilterAll': 'Toate',
	'pinDateFilterToday': 'Azi',
	'pinDateFilterYesterday': 'Ieri',
	'pinDateFilterPastWeek': 'Săptămâna trecută',
	'pinDateFilterPastMonth': 'Luna trecută',
	'pinDateFilterEarlier': 'Mai devreme',

	// data widget contextual toolbar labels
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'toolbarActionEditTitle': 'Editare titlu',
	'toolbarActionSort': 'Sortare',
	'toolbarActionSortAscending': 'Sortare crescătoare',
	'toolbarActionSortDescending': 'Sortare descrescătoare',
	'toolbarActionSortAuto': 'Auto (%{sortOrder})',
	'toolbarActionFormat': 'Format data',
	'toolbarActionFormatAbbreviation': 'Abreviere',
	'toolbarActionFormatNone': 'Automat',
	'toolbarActionFilter': 'Filtru',
	'toolbarActionTopBottom': 'Vârf sau sfârşit',
	'toolbarActionAddShape': 'Adăugare formă',
	'toolbarActionRmvShape': 'Înlăturare formă',
	'toolbarActionToggleShapeDrop': 'Formă infografic',
	'toolbarActionToggleShapeDropTitle': 'Creare infografic',
	'toolbarActionToggleShapeDropText': 'Trageţi o formă în acest câmp pentru a crea un infografic.',
	'toolbarActionAggregationType': 'Sumarizare',
	'toolbarDeleteActionText': 'Înlăturare coloană',
	'toolbarActionFilterLocalKeepSelected': 'Păstrare',
	'toolbarActionFilterLocalExcludeSelected': 'Excludere',
	'toolbarActionFilterAllKeepSelected': 'Filtru',
	'toolbarActionSimpleCalculation': 'Calcul simplu',
	'toolbarActionDrillBack': 'Înapoi',
	'toolbarActionDrillUp': 'Drill up',
	'toolbarActionDrillDown': 'Drill down',
	'toolbarActionNavigate': 'Navigare',
	'toolbarActionCreateFilterGroup': 'Creare conexiune nouă',
	'toolbarActionDisconnectFilterGroup': 'Întrerupere toate legăturile',
	'toolbarActionLinkFilterGroup': 'Adăugare la o conexiune existentă',

	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',

	// Side bar
	'sidebarAdd': 'Adăugare',
	'sidebarMultiselect': 'Comutare selecţii multiple',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'multiselectMsg': '%{count} selected',

	'multiselectWithTotalMsg': '%{count} of %{total}',
	'sidebarGoBack': 'Deplasare înapoi',

	//DataSet pane
	'errorLoadingDataSets': 'Nu putem încărca acest set de date',
	'errorLoadingDataSetMetaData': 'Nu putem încărca acest set de date',
	'dataSetPaneLastUpdated': 'Last updated: %{date}',
	'dataSetPaneDateUnknown': 'Necunoscut',
	'sourcePaneLabel': 'Surse selectate',
	'addSourceLabel': 'Adăugarea unei surse',
	'find_label': 'Găsire',
	'navigationPathsLabel': 'Căi de navigare',

	//widgetlist
	'errorLoadingWidgetList': 'Nu putem încărca obiectele.',
	'errorLoadingThemeFile': 'Nu putem încărca definiţia temei',
	'errorLoadingLayoutFile': 'Nu putem încărca vizualizarea.',

	//data widget

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'dwErrorLoadingAvailableVisualizations': 'Nu putem încărca definiţiile de vizualizare disponibile',

	'dwErrorLoadingVisualizationNotFound': 'Nu putem încărca obiectul deoarece lipseşte o definiţie de vizualizare',
	'dwErrorLoadingVisualizationListNotFound': 'Nu putem încărca vizualizarea.',
	'dwErrorRunningQuery': 'We can\'t retrieve the data from data set %{datasetName}.',
	'dwErrorGeoData': 'Avem probleme cu afişarea datelor geografice într-o hartă. Vă rugăm să alegeţi alt tip de vizualizare. ',
	'dwPromptSignonCancelWarning': 'Datele pentru această vizualizare nu sunt disponibile. Vă rugăm să furnizaţi acreditările corecte.',
	'dwErrorMissingDataset': 'We can\'t load the visualization, because its associated data set \'%{datasetName}\' isn\'t available.',
	'dwErrorRenderingVisualization': 'Nu putem încărca  această vizualizare.',
	'dwErrorVisualizationTooSmall': 'Vizualizarea este prea mică pentru a afişa datele pe care le conţine. Faceţi vizualizarea mai mare sau limitaţi datele pe care le conţine.',
	'aria_label_datatable': 'Tabel de date',
	'aria_key_navi_datatable_desc': 'Utilizaţi tastele săgeţi pentru a naviga la fiecare celulă. Apăsaţi tastele Control şi Home pentru a vă muta la primul rând, Control şi End pentru a vă muta la ultimul rând.',
	'geomapUnrecognizedLocations': 'Locaţii nerecunoscute:',
	'geomapAmbiguousLocations': 'Regiuni ambigue:',

	// custom widget
	'customWidget': 'Widget personalizat',
	'customWidgetsTitle': 'Widget-uri personalizate',
	'noCustomWidgets': 'Niciun widget personalizat',

	// Action names
	'toggleContextBar': 'Comutarea barei de context',
	'delete': 'Ştergere',
	'share': 'Partajare',
	'unshare': 'Anulare partajare',
	'rename': 'Redenumire',
	'close': 'Închidere',
	'duplicate': 'Duplicare',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'retry': 'Reîncercare',

	'changeTemplate': 'Modificare şablon',

	// Aggregation Types
	'sum': 'Sumă',
	'count': 'Numărare',
	'countdistinct': 'Număr distinct',
	'avg': 'Mediu',
	'min': 'Minim',
	'max': 'Maxim',
	'custom': 'Personalizat',
	'calculated': 'Calculat',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8

	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})', // For example, the sum of Revenue

	//simple calculation
	'percDifferenceOp': 'Modificare %',
	//For example, Profit - Expenses
	'calculationTitle': '%{col1} %{operator} %{col2}',

	'templateWidgetPlaceholderInput': 'Vizualizare criterii...',
	'QuickAddResultsHeader': 'Vizualizări de date',
	'NoQuickAddResults': 'Nimic potrivit cu intenţia dumneavoastră. Creaţi un nou set de date?',
	'NoQuickAddResultsRetry': 'Nu putem găsi nicio potrivire. Încercaţi din nou cu termeni diferiţi.',
	'templateWidgetTitle': 'Şablon',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'nullValueLabel': '(necompletat)',

	'nullValueContent': '(nicio valoare)',
	'nullValueText': 'Nul',

	// Modelling / Data Shaping
	'textFilterControlRegionLabel': 'Text filter - %{columnName}',

	'textFilterSelectTab': 'Selectare',

	'textFilterConditionTab': 'Setaţi o condiţie',
	'textFilterItemsSelected': '(%{selected})',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'textFilterItemsNotFound': 'Nu sunt disponibile articole.',

	'textFilterEquals': 'Este egal cu',
	'textFilterContains': 'Conţine',
	'textFilterBeginsWith': 'Începe cu',
	'textFilterEndsWith': 'Se termină cu',
	'textFilterDoesNotEqual': 'Nu este egal cu',
	'textFilterDoesNotContain': 'Nu conţine',
	'textFilterDoesNotBeginWith': 'Nu începe cu',
	'textFilterDoesNotEndWith': 'Nu se termină cu',
	'textFilterSampleText': 'De exemplu: A',

	'textFilterAndButton': 'And',
	'textFilterOrButton': 'Or',

	'dateFilterMessage': 'Selectare un interval de date',
	'dateRangeControlRegionLabel': 'Date range filter - %{columnName}',
	'dateFilterRangeOption': 'Opţiune interval',
	'dateFilterDateLabel': 'Dată',
	'dateFilterBlank': '(necompletat)',
	'dateFilterBefore': 'Înainte',
	'dateFilterAfter': 'După',
	'dateFilterBetween': 'Între',
	'dateFilterSampleText': 'YYYY-MM-DD',
	'dateTitle': 'Dată',
	'dateIncludeBlankLabel': 'Includere dată necompletată',

	'timeTitle': 'Oră',
	'timeFilterMessage': 'Selectaţi un interval de momente',
	'dateTimeFilterMessage': 'Selectaţi un interval de date şi ore',

	'topbottomNumberOfResultsLabel': 'Număr de rezultate',
	'topbottomPercentLabel': 'Procent',
	'topbottomNumberOfResultsLimit': 'Between %{lower}-%{higher}',
	'topbottomSelectOption': 'Opţiune Vârf sau sfârşit:',
	'topbottomOptionLabel': 'Afişare',
	'searchByLabel': 'De',
	'searchNoMatches': 'Nu s-a găsit nicio potrivire',
	'topbottomRankColumnLabel': 'Adăugare în tabel coloană de rang',
	'topbottomNone': 'Fără',
	'topCount': 'Număr primele',
	'topPercent': 'Primele %',
	'bottomCount': 'Număr ultimele',
	'bottomPercent': 'Ultimele %',
	'topbottomSearchColumn': 'Găsirea unei coloane',
	'searchColumnAriaLabel': 'Găsiţi o coloană. Tastaţi numele coloanei de căutat, apoi utilizaţi săgeata în jos pentru a găsi coloana într-o listă',
	'rankColumnLabel': 'Rank (%{columnLabel})',
	'topbottomClearLabel': 'Curăţare',

	'rangeFilterControlRegionLabel': 'Range filter - %{columnName}',

	// Slider
	'sliderRegionLabel': 'Control slider, utilizaţi săgeţile stânga şi dreapta pentru a muta handle-urile slider-ului',
	'sliderHandleLabel': 'Handle slider',
	'a11ySliderHandleLabel': 'Slider handle %{sliderValue}',
	'sliderInputLabel': 'valoare',

	// Refinery - Hidden columns
	'datasetItemsUnavailable': 'Unele articole din setul de date utilizate în această vizualizare nu sunt disponibile.',
	'datasetItemUnavailable': 'Acest articol de set de date nu este disponibil',

	//Authoring topBottom
	'topOperator': 'Sus',
	'bottomOperator': 'Jos',
	//For dimension column. eg: Top 5 by Quantity. %{operator} is topOperator or bottomOperator, %{val} is a number and %{fact} is a column name.
	'topBottomFact': '%{operator} %{value} by %{columnLabel}',
	//For fact column. eg: Top 10. %{operator} is topOperator or bottomOperator and %{val} is a number.
	'topBottomDimension': '%{operator} %{value}',
	'topBottomTitle': 'Numai acest obiect',
	'deleteTopBottom': 'Ştergere număr primele sau ultimele',
	'editTopBottom': 'Editare număr primele sau ultimele',
	'deleteDrillState': 'Ştergere stare curentă drill',
	'ariaDeleteDrillStateLabel': 'Apăsaţi tasta ENTER pentru a edita numărul pentru primele sau ultimele.',
	'drillUpStateTitle': 'Drill Up',
	'drillDownStateTitle': 'Drill Down',
	'ariaEditTopBottomLabel': 'Apăsaţi tasta ENTER pentru a edita numărul pentru primele sau ultimele.',
	'ariaDeleteTopBottomLabel': 'Apăsaţi tasta DELETE pentru a şterge numărul pentru primele sau ultimele.',

	// Authoring filtering
	'dimFilterIn': 'Includes: %{in}',
	'dimFilterNotIn': 'Excludes: %{out}',
	'measureFilterBetween': 'Between %{lowerBound} and %{upperBound}',
	'measureFilterNotBetween': 'Not between %{lowerBound} and %{upperBound}',
	'gtFilter': 'After %{lowerBound}',
	'ltFilter': 'Before %{upperBound}',
	'notGtFilter': 'Not after %{lowerBound}',
	'notLtFilter': 'Not before %{upperBound}',
	'localFilterTitle': 'Numai acest obiect',
	'globalFilterTitle': 'Toate obiectele',
	'deleteFilter': 'Ştergere filtru',
	'editFilter': 'Editare filtru',
	'ariaEditFilterLabel': 'Apăsaţi Enter pentru a edita filtrul.',
	'ariaDeleteFilterLabel': 'Apăsaţi tasta DELETE pentru a şterge filtrul.',

	// Prompts
	'ariaEditPrompt': 'Apăsaţi tasta ENTER pentru a schimba valoarea promptului',

	'moreDataIndicator': 'Your data was clipped at %{threshold} items. Aplicaţi un filtru pentru a afişa mai puţin',

	// data point filtering
	'dataPointFilterTitle': 'Puncte date',
	'dataPointFilterIncludeSummary': 'Included %{valueCount} data points',
	'dataPointFilterExcludeSummary': 'Excluded %{valueCount} data points',

	// DB2 connection page
	'db2Database': 'DB2 Database (%{jdbcConnection})',
	'db2Title': 'Conectare la IBM DB2',

	// Database
	'databaseConnectionMessage': 'Furnizaţi detaliile de conexiune la baza dumneavoastră de date:',
	'connectionString': 'Şir de conexiune bază de date',
	'databaseCredentials': 'Acreditări: ',
	'databaseUserName': 'Nume utilizator',
	'databasePassword': 'Parolă',
	'databaseConnect': 'Conectare',

	// Twitter Keyword page
	'twitterTitle': 'Twitter',
	'twitterKeywordMessage': 'Introduceţi un termen de căutare:',
	'twitterKeyword': 'Cuvânt cheie',
	'twitterSearch': 'Căutare',

	// NewConnectionView Providers
	'twitterProvider': 'Twitter',
	'dropboxProvider': 'Dropbox',
	'db2Provider': 'DB2',

	'workbookCreateFailed': 'We can\'t create the view: %{error}\nFailed operation: %{lastOp}',

	// Expanded View, Focus View
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'widgetFiltersLabel': 'Filtre widget',
	'missingColumn': 'Missing: %{columnLabel}',
	'missingFiltering': 'Filtre lipsă pe următoare ID-uri de coloane:',
	'heatByLabel': 'Căldură după',
	'evColumns': 'Coloane',
	'evLocalFilters': 'Filtre locale',
	'evExpand': 'Expandare',
	'evFilterTooltip': 'Filtru',
	'evAdd': 'Adăugarea unei coloane',

	// Navigation View
	'navigationBack': 'Înapoi',

	// Pinning
	'contentPinFail': 'Nu putem colecta conţinutul. Încercaţi din nou mai târziu.',
	'contentPinFailOld': 'Nu putem ţintui conţinutul. Încercaţi din nou mai târziu.',

	// Layouts
	'dropZoneLabel': 'Plasaţi aici pentru a maximiza',

	//Share
	'shareDefaultPageTitle': 'Page %{index}',

	'nextPage': 'Pagina următoare',
	'previousPage': 'Pagina anterioară',

	'assetAssembly': 'vizualizare',

	'toolbar_save': 'Salvare',
	'brgr_saveAs': 'Salvare ca',
	'brgr_refresh': 'Reîmprospătare',

	// Save
	'saving': 'Salvare...',
	'save_success': 'Vizualizarea dumneavoastră a fost salvată.',
	'save_failure': 'Ne pare rău. Vizualizarea dumneavoastră nu a putut fi salvată. Încercaţi din nou mai târziu.',
	'dashboard_save_success': 'Tabloul dumneavoastră de bord a fost salvat.',

	'geminiLeave': 'Sunteţi pe cale să părăsiţi IBM Watson Analytics.',

	'warning': 'Avertisment',
	'missingDataSetData': 'Datele pentru acest set de date nu sunt disponibile. Reîmprospătaţi setul de date sau contactaţi-vă administratorul pentru accesul la sursă.',

	// Calculations
	'error_calculation_in_use': 'Calculul selectat este în uz şi nu poate fi şters.',

	'resize': 'Redimensionare',
	'rotate': 'Rotaţie',
	'moveHandle': 'Mutare widget',
	'expandHandle': 'Expandare',
	'panHandle': 'Pan',

	//Navigation
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'navigateTitle': 'Navigare la',

	// Slide out titles
	'shapeSlideoutTitle': 'Forme',
	'textSlideoutTitle': 'Text',
	'mediaSlideoutTitle': 'Media',
	'visualizationSlideoutTitle': 'Vizualizări',

	// Board Model Dialog Messages
	'invalidJSONResponse': 'JSON-ul furnizat este invalid. Vedeţi jurnalul de erori pentru informaţii suplimentare.',

	// Widget type labels
	'shape_label': 'Formă',
	'image_label': 'Imagine',
	'data_label': 'Diagramă',
	'media_label': 'Media',
	'text_label': 'Text',
	'embedMedia_label': 'Media',
	'youtube_label': 'Video YouTube',
	'webpage_label': 'Pagină web',

	// **** Smart names for objects ****
	// You might think that one_name is useless, but we have it in case we need to change that resource into one_name_numbered
	'one_name': '%{name}',
	'one_name_numbered': '%{name} (%{number})',
	'noExtraText_shape': 'Formă',
	'noExtraText_shape_numbered': 'Shape (%{number})',
	'few_shape': 'Group of %{count} shapes',
	'many_shape': 'Group of %{count} shapes',
	// %{text} is the description of the image, specified in the properties by the user
	'one_image': '%{text} image',
	'one_image_numbered': '%{text} image (%{number})',
	'noExtraText_image': 'Imagine',
	'noExtraText_image_numbered': 'Image (%{number})',
	'few_image': 'Group of %{count} images',
	'many_image': 'Group of %{count} images',
	'noExtraText_text': 'Casetă de text goală',
	'noExtraText_text_numbered': 'Empty text box (%{number})',
	'few_text': 'Group of %{count} text boxes',
	'many_text': 'Group of %{count} text boxes',
	//pa cube viewer
	'pacubeviewer_no_mapping': 'Cube viewer',
	'pacubeviewer_named': '%{name} Cube viewer',
	// Crosstab: values by Row1 (and Column1)
	'crosstab_opt_mapping': '%{values} by %{row_level1} and %{column_level1} crosstab',
	'crosstab_opt_mapping_numbered': '%{values} by %{row_level1} and %{column_level1} (%{number}) crosstab',
	'crosstab_has_mapping': '%{values} by %{row_level1} crosstab',
	'crosstab_has_mapping_numbered': '%{values} by %{row_level1} (%{number}) crosstab',
	'crosstab_no_mapping': 'Tabel încrucişat gol',
	'crosstab_no_mapping_numbered': 'Empty crosstab (%{number})',
	'crosstab_named': '%{name} crosstab',
	'crosstab_named_numbered': '%{name} crosstab (%{number})',
	// Grid: first column grid
	'JQGrid_has_mapping': '%{grid_cols} table',
	'JQGrid_has_mapping_numbered': '%{grid_cols} table (%{number})',
	'JQGrid_no_mapping': 'Tabel gol',
	'JQGrid_no_mapping_numbered': 'Empty table (%{number})',
	'JQGrid_named': '%{name} table',
	'JQGrid_named_numbered': '%{name} table (%{number})',
	// Hierarchy: level one hierarchy
	'hierarchy_has_mapping': '%{level1} hierarchy',
	'hierarchy_has_mapping_numbered': '%{level1} hierarchy (%{number})',
	'hierarchy_no_mapping': 'Ierarhie goală',
	'hierarchy_no_mapping_numbered': 'Empty hierarchy (%{number})',
	'hierarchy_named': '%{name} hierarchy',
	'hierarchy_named_numbered': '%{name} hierarchy (%{number})',
	// Legacy map: Region heat by Regions map
	'map_has_mapping': '%{categories} map',
	'map_has_mapping_numbered': '%{categories} map (%{number})',
	'map_no_mapping': 'Hartă goală',
	'map_no_mapping_numbered': 'Empty map (%{number})',
	'map_named': '%{name} map',
	'map_named_numbered': '%{name} map (%{number})',
	// Summary value: value summary value
	'summary_has_mapping': '%{actual} summary value',
	'summary_has_mapping_numbered': '%{actual} summary value (%{number})',
	'summary_no_mapping': 'Valoare de sumar goală',
	'summary_no_mapping_numbered': 'Empty summary value (%{number})',
	'summary_named': '%{name} summary value',
	'summary_named_numbered': '%{name} summary value (%{number})',

	// KPI: actual value, optional time
	'kpi_opt_mapping': '%{actual} by %{sparkline.time} KPI',
	'kpi_opt_mapping_numbered': '%{actual} by %{sparkline.time} KPI (%{number})',
	'kpi_has_mapping': '%{actual} KPI',
	'kpi_has_mapping_numbered': '%{actual} KPI (%{number})',
	'kpi_no_mapping': 'KPI gol',
	'kpi_no_mapping_numbered': 'Empty KPI (%{number})',
	'kpi_named': '%{name} KPI',
	'kpi_named_numbered': '%{name} KPI (%{number})',

	// (Infographic summary) Infographic: value infographic
	'infographicSummary_has_mapping': '%{actual} infographic',
	'infographicSummary_has_mapping_numbered': '%{actual} infographic (%{number})',
	'infographicSummary_no_mapping': 'Infografic gol',
	'infographicSummary_no_mapping_numbered': 'Empty infographic (%{number})',
	'infographicSummary_named': '%{name} infographic',
	'infographicSummary_named_numbered': '%{name} infographic (%{number})',
	'noExtraText_youtube': 'Video YouTube',
	'noExtraText_youtube_numbered': 'YouTube video (%{number})',
	// %{text} is the user-provided title of the video
	'one_youtube': '%{text} YouTube video',
	'one_youtube_numbered': '%{text} YouTube video (%{number})',
	'few_youtube': 'Group of %{count} YouTube videos',
	'many_youtube': 'Group of %{count} YouTube videos',
	'noExtraText_embedMedia': 'Legătură la mediu',
	'noExtraText_embedMedia_numbered': 'Media link (%{number})',
	// %{text} is the user-provided title of the media link
	'one_embedMedia': '%{text} media link',
	'one_embedMedia_numbered': '%{text} media link (%{number})',
	'few_embedMedia': 'Group of %{count} media links',
	'many_embedMedia': 'Group of %{count} media links',
	'noExtraText_media': 'Media',
	'noExtraText_media_numbered': 'Media (%{number})',
	// %{text} is the user-provided title of the media link
	'one_media': '%{text} media',
	'one_media_numbered': '%{text} media (%{number})',
	'few_media': 'Group of %{count} media',
	'many_media': 'Group of %{count} media',
	'noExtraText_webpage': 'Pagină web',
	'noExtraText_webpage_numbered': 'Web page (%{number})',
	// %{text} is the user-provided title of the web page
	'one_webpage': '%{text} web page',
	'one_webpage_numbered': '%{text} web page (%{number})',
	'few_webpage': 'Group of %{count} web pages',
	'many_webpage': 'Group of %{count} web pages',
	'one_unknown': 'Un obiect',
	'one_unknown_numbered': 'An object (%{number})',
	'few_unknown': 'Group of %{count} objects',
	'many_unknown': 'Group of %{count} objects',

	//a11y label for the left/right arrow for navigation path

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'next': 'Următor',
	'previous': 'Anterior',
	//a11y description

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'current_nav_group': 'Current navigation group is %{navigation_group_name}',

	//Page Context
	'filterBlank': '(necompletat)',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'errMsgFilterItemGenericTitle': 'Valorile de filtrare nu au putut fi încărcate',
	'editTimelineHighlight': 'Editare evidenţiere',

	'filterDockChevronLeft': 'Defilaţi prin date',
	'filterDockChevronRight': 'Defilaţi prin date',
	'expand': 'Expandare',
	'collapse': 'Restrângere',

	//Reset Dashboard
	'dashboardResetTitle': 'Resetare tablou de bord',
	'dashboardResetMessage': 'Sunteţi sigur că vreţi să resetaţi toate modificările aplicate acestui tablou de bord?',
	'dashboardResetToast': 'Tabloul dumneavoastră de bord a fost resetat.',

	//Generate PDF
	'buildingPDF': 'Construire PDF...',
	'exportPDF': 'Export în PDF',
	'pageSize': 'Mărime pagină',
	'orientation': 'Orientare',
	'filtersPresentPDF': 'Filtrele aplicate vizualizărilor pe pagina anterioară:',
	'errorPDF': 'Nu poate fi generat PDF-ul. Reîmprospătaţi şi încercaţi din nou.',
	'printPDFInfo': 'Vizualizare documentaţie',
	'pdfWidget': 'Widget',
	'includeFilters': 'Afişare detalii filtru',
	'portrait': 'Portret',
	'landscape': 'Vedere',
	'letter': 'Letter',
	'legal': 'Legal',
	'a4':'A4',
	'tabloid':'Tabloid',

	'toastUpgradeDone': 'Tabloul dumneavoastră de bord a fost actualizat. Salvaţi acum pentru a menţine performanţa optimă.',

	'ariaFullScreenMessage': 'Apăsaţi Escape pentru a ieşi din modul ecran complet',

	/**********************************************
	*******************LIVE WIDGET*****************
	***********************************************/
	// Hierarchy Packed Bubble
	'LIVE_hierarchy_packed_bubble_has_mapping': '%{categories} packed hierarchy bubble chart',
	'LIVE_hierarchy_packed_bubble_has_mapping_numbered': '%{categories} packed hierarchy bubble chart (%{number})',
	'LIVE_hierarchy_packed_bubble_no_mapping': 'Diagramă cu bule de ierarhie împachetate goală',
	'LIVE_hierarchy_packed_bubble_no_mapping_numbered': 'Empty packed hierarchy bubble chart (%{number})',
	'LIVE_hierarchy_packed_bubble_named': '%{name} packed hierarchy bubble chart',
	'LIVE_hierarchy_packed_bubble_named_numbered': '%{name} packed hierarchy bubble chart (%{number})',

	// Marimekko
	'LIVE_marimekko_has_mapping': '%{categories} by %{values} marimekko chart',
	'LIVE_marimekko_has_mapping_numbered': '%{categories} by %{values} marimekko chart (%{number})',
	'LIVE_marimekko_no_mapping': 'Diagramă Marimekko goală',
	'LIVE_marimekko_no_mapping_numbered': 'Empty marimekko chart (%{number})',
	'LIVE_marimekko_named': '%{name} marimekko chart',
	'LIVE_marimekko_numbered': '%{name} marimekko chart (%{number})',

	// Sunburst
	'LIVE_sunburst_has_mapping': '%{values} sunburst chart',
	'LIVE_sunburst_has_mapping_numbered': '%{values} sunburst chart (%{number})',
	'LIVE_sunburst_no_mapping': 'Diagramă explozie solară goală',
	'LIVE_sunburst_no_mapping_numbered': 'Empty sunburst chart (%{number})',
	'LIVE_sunburst_named': '%{name} sunburst chart',
	'LIVE_sunburst_named_numbered': '%{name} sunburst chart (%{number})',

	// Driver Analysis
	'LIVE_decision_analysis_has_mapping': '%{values} driver analysis chart',
	'LIVE_decision_analysis_has_mapping_numbered': '%{values} driver analysis chart (%{number})',
	'LIVE_decision_analysis_no_mapping': 'Diagramă de analiză driver gol',
	'LIVE_decision_analysis_no_mapping_numbered': 'Empty driver analysis chart (%{number})',
	'LIVE_decision_analysis_named': '%{name} driver analysis chart',
	'LIVE_decision_analysis_named_numbered': '%{name} driver analysis chart (%{number})',

	// Line and Column
	'LIVE_line_column_opt_mapping': '%{categories} by %{columnValue} and %{lineValue} line and column chart',
	'LIVE_line_column_opt_mapping_numbered': '%{categories} by %{columnValue} and %{lineValue} line and column chart (%{number})',
	'LIVE_line_column_has_mapping': '%{columnValue} and %{lineValue} line and column chart',
	'LIVE_line_column_has_mapping_numbered': '%{categories} by %{columnValue} and %{lineValue} line and column chart (%{number})',
	'LIVE_line_column_no_mapping': 'Diagramă cu linii şi coloane goală',
	'LIVE_line_column_no_mapping_numbered': 'Empty line and column chart (%{number})',
	'LIVE_line_column_named': '%{name} line and column chart',
	'LIVE_line_column_named_numbered' : '%{name} line and column chart (%{number})',

	// Bubble chart
	'LIVE_bubble_chart_has_mapping': '%{x} by %{y} and %{size} bubble chart',
	'LIVE_bubble_chart_has_mapping_numbered': '%{x} by %{y} and %{size} bubble chart (%{number})',
	'LIVE_bubble_chart_no_mapping': 'Diagramă cu bule goală',
	'LIVE_bubble_chart_no_mapping_numbered': 'Empty bubble chart (%{number})',
	'LIVE_bubble_chart_named': '%{name} bubble chart',
	'LIVE_bubble_chart_named_numbered': '%{name} bubble chart (%{number})',

	// Bullet chart
	'LIVE_bullet_has_mapping': '%{actual} bullet chart',
	'LIVE_bullet_has_mapping_numbered': '%{actual} bullet chart (%{number})',
	'LIVE_bullet_no_mapping': 'Diagramă marcator goală',
	'LIVE_bullet_no_mapping_numbered': 'Empty bullet chart (%{number})',
	'LIVE_bullet_named': '%{name} bullet chart',
	'LIVE_bullet_named_numbered': '%{name} bullet chart (%{number})',

	// powered by feature
	'ibmDb2': 'IBM Db2',
	'dashboardPoweredByPrefix': 'Datele din acest tablou de bord sunt furnizate de',
	'showFooterToggleButtonText': 'Afişare subsol',
	'showFooterSectionText': 'Subsol'
});
